
/* injects from baggage-loader */

'use strict';

export default function (app) {
	app.service('User', function (Parse, $q, $state, $log) {

		// ==================================================
		// Methods
		// ==================================================


		/**
		 * Returns the current user
		 */
		this.getCurrent = () => Parse.User.current();


		/**
		 * Returns true if a User is currently logged in
		 */
		this.isUserLoggedIn = () => this.getCurrent() ? true : false;


		/**
		 * Authenticate user login credentials and grant access to the portal if successful
		 */
		this.authenticate = (creds, destination = 'account.home') => {

			// return Parse.User.logIn(creds.email, creds.password);

			let d = $q.defer();

			// Contact the server and attempt to authenticate the User
			Parse.User.logIn(creds.email, creds.password)
				.then(user => {

					// Mark last login attempt successful
					// ServerEvent.markLoginSuccessful();

					// Login successful
					d.resolve(true);

					// Navigate to destination page
					// if (destination !== false) {
					// 	$state.go(destination);
					// }

				})
				.catch(err => d.reject(err));

			return d.promise;

		}


		/**
		 * Logout current User
		 */
		this.logout = (destination = 'login', error_destination = 'home') => {

			let d = $q.defer();

			Parse.User.logOut()
				.then(user => {

					// Logout successful
					d.resolve(true);

					// Navigate to destination page
					$state.go(destination);

				})
				.catch(err => {

					// Return error
					d.reject(err);

					// Navigate to error handled destination page
					$state.go(error_destination);

				});

			return d.promise;
		}


		/**
		 * Create a new User account
		 */
		this.signup = user => {

			let d = $q.defer();

			// Check for current user, reject signup if true
			if (this.isUserLoggedIn === true) {
				d.reject('Cannot process signup, a user is already logged in.');
			}


			// Set username
			user.username = user.email;

			// Remove the duplicate password
			delete user.password_verify;

			// Create a new Parse User object
			let newUser = new Parse.User(user);
			// newUser.set('username', user.email);
			// newUser.set('email', user.email);
			// newUser.set('password', user.password);

			// Contact the server and tell it we want to create a new User
			newUser.signUp()
				.then(_user => {
					$log.log(_user)
					// Signup successful, return user
					d.resolve(_user);
				})
				.catch(err => {
					// Signup failed, return error
					d.reject(err);
				});

			return d.promise;

		}


		/**
		 * Send an email to the user with instructions to reset their password
		 */
		this.resetPassword = email => {

			let d = $q.defer();

			Parse.User.requestPasswordReset(email)
				.then(() => {
					d.resolve(true);
				})
				.catch(err => {
					d.reject(err);
				});

			return d.promise;

		}

	});
}




// WEBPACK FOOTER //
// ./src/app/core/services/user.service.js